module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "onboarding-tours": "static-1.17366"
    },
    "depPathPrefixes": {
      "onboarding-tours": "/onboarding-tours/static-1.17366"
    },
    "bundlingPackage": "page-editor-ui",
    "bundlingPackageVersion": "static-1.39570",
    "project": "onboarding-tours",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};